import React from 'react'
import PropTypes from 'prop-types'

const ChevronRightCircle = ({ width = 39, height = width, fill = '#404040', color = 'white' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 38 39"
      fill="none">
      <circle cx="19.0001" cy="19.3554" r="19" fill={fill} />
      <path
        d="M14.4207 27.9812C14.1514 27.7415 14.0001 27.4165 14.0001 27.0776C14.0001 26.7387 14.1514 26.4137 14.4207 26.174L21.5322 19.8477L14.4207 13.5213C14.159 13.2803 14.0142 12.9575 14.0175 12.6224C14.0207 12.2873 14.1718 11.9667 14.4382 11.7297C14.7046 11.4928 15.0649 11.3584 15.4416 11.3555C15.8183 11.3525 16.1812 11.4814 16.4522 11.7142L24.5794 18.9441C24.8488 19.1838 25.0001 19.5088 25.0001 19.8477C25.0001 20.1866 24.8488 20.5116 24.5794 20.7513L16.4522 27.9812C16.1827 28.2208 15.8174 28.3554 15.4364 28.3554C15.0555 28.3554 14.6901 28.2208 14.4207 27.9812Z"
        fill={color}
      />
    </svg>
  )
}

ChevronRightCircle.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  color: PropTypes.string,
}

export default React.memo(ChevronRightCircle)
